import { useEffect, useState } from "react";

import { useRootDispatch, useRootSelector } from "../../../store/hooks";
import {
  clearNotification,
  clearSlideoutNotifications,
} from "../../../store/notification/notification-slice";
import classes from "./Notifications.module.scss";

import { NotificationMsg } from "./notificationMsg/NotificationMsg";

export const SlideoutNotifications = ({ isOpen }: { isOpen: boolean }) => {
  const { notifications } = useRootSelector((state) => state.notification);
  const dispatch = useRootDispatch();
  const [isDismissing, setIsDissmissing] = useState(false);

  const handleDismiss = (id: string) => {
    setIsDissmissing(true);
    setTimeout(() => {
      dispatch(clearNotification(id));
      setIsDissmissing(false);
    }, 300);
  };

  useEffect(() => {
    if (!isOpen) {
      dispatch(clearSlideoutNotifications());
    }
  }, [isOpen, dispatch]);

  const dismissibleNotification = notifications.find(
    (n) => n.slideout && n.closable
  );
  if (!dismissibleNotification || isDismissing) {
    return null;
  }

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <NotificationMsg
          type={dismissibleNotification.type}
          messages={dismissibleNotification.messages}
          translatedMessages={dismissibleNotification.translatedMessages}
          isClosable={true}
          isDismissing={isDismissing}
          onClose={() => handleDismiss(dismissibleNotification.id)}
        />
      </div>
    </div>
  );
};
